/**********************
 * BLOG (Norsk)
 **********************/
import { Card, CardContent } from "./card";
import { Sparkles, BookOpen } from "lucide-react";
import { Button } from "./button";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { ArticleModal } from "../../utilities/blogutils";

export function Blogs({ T, from, baseUrl, client, limit }) {
  const [posts, setPosts] = useState([]);
  const [openPost, setOpenPost] = useState(null);

  const getPosts = async () => {
    if (limit === "none") limit = "";
    try {
      const response = await axios(baseUrl + "/getBlogs", {
        params: {
          client_uid: client?.uid,
          limit: limit,
        },
      });

      if (response.data.status === "OK") {
        let blogPosts = Array.isArray(response.data.data)
          ? response.data.data
          : [];

        setPosts(blogPosts.length ? blogPosts : []);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getPosts();
  }, [baseUrl, client?.uid])

  const footer_settings = client ? JSON.parse(client.footer_settings) : null;
  // const posts = [
  //   {
  //     title: "Navratri: 9 netter for fornyelse",
  //     excerpt: "Ritualer, farger og intensjoner – én for hver Navratri‑dag.",
  //     tag: "Festival",
  //     img: "https://images.unsplash.com/photo-1601731816741-097824f756d9?q=80&w=1600&auto=format&fit=crop",
  //   },
  //   {
  //     title: "Slik velger du veileder",
  //     excerpt: "Klarsynt, Tarot eller Astrologi? Finn rett retning for spørsmålet ditt.",
  //     tag: "Guide",
  //     img: "https://images.unsplash.com/photo-1526318472351-c75fcf070305?q=80&w=1600&auto=format&fit=crop",
  //   },
  //   {
  //     title: "Diwali‑ritualer for velstand",
  //     excerpt: "Enkel Lakshmi‑puja og moderne praksiser du kan gjøre hjemme.",
  //     tag: "Velstand",
  //     img: "https://images.unsplash.com/photo-1605727216801-e27ce1d0cc28?q=80&w=1600&auto=format&fit=crop",
  //   },
  //   {
  //     title: "Drømmesymboler 101",
  //     excerpt: "Slanger, vann, fall – hva prøver drømmene å si?",
  //     tag: "Drømmer",
  //     img: "https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=1600&auto=format&fit=crop",
  //   },
  //   {
  //     title: "Tarot for nybegynnere",
  //     excerpt: "En 3‑korts legg: fortid, nåtid, utfall – på 5 minutter.",
  //     tag: "Tarot",
  //     img: "https://images.unsplash.com/photo-1620504156306-4f6e1980f360?q=80&w=1600&auto=format&fit=crop",
  //   },
  //   {
  //     title: "Overlev Merkur retrograd",
  //     excerpt: "Kommunikasjonstips og beskyttelse når Merkur snur.",
  //     tag: "Astrologi",
  //     img: "https://images.unsplash.com/photo-1475855581690-80accde3ae2b?q=80&w=1600&auto=format&fit=crop",
  //   },
  // ];

  return (
    <section className="py-12 px-4 max-w-7xl mx-auto">
      <div className="flex items-end justify-between mb-6">
        <h2 className="text-2xl md:text-3xl font-extrabold text-[var(--primary-color)]">{footer_settings?.logo_home_not_sqaure ? (
          <span>{footer_settings.company_brand_name}</span>
        ) : client.client_name} Blogs</h2>
        {from !== "blogpage" && (<a href="/blogs" className="rounded-lg text-white px-5 py-2 shadow transition hover:brightness-90" style={{ backgroundColor: "var(--primary-color)" }}>{T.viewAll}</a>)}
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((p, i) => (
          <Card
            key={i}
            className="rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition bg-gradient-to-b from-purple-50 to-white"
            style={{ backgroundImage: "linear-gradient(to bottom, var(--primary-color), var(--secondary-color))" }}
          >
            <div className="relative h-56 w-full overflow-hidden">
              <img src={p.imageUrl} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <CardContent className="p-5">
              <span className="inline-flex items-center gap-1 text-xs font-semibold bg-[var(--secondary-color)] text-[var(--primary-color)] px-2 py-1 rounded-full">
                <Sparkles className="w-3 h-3" /> {p.template}
              </span>
              <h3 className="mt-3 text-lg font-bold text-gray-900">{p.title}</h3>
              <p className="mt-1 text-sm text-gray-600">{p.subtitle}</p>
              <div className="mt-4 flex items-center justify-between">
                <button variant="outline" onClick={() => setOpenPost(p)} className="inline-flex items-center justify-center font-medium transition focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none rounded-md px-4 py-2 text-sm rounded-full border-[var(--primary-color)] text-[var(--primary-color)] bg-[var(--secondary-color)] shadow transition hover:brightness-90">
                  {T.read}
                </button>
                <div className="text-xs text-gray-500 flex items-center gap-2">
                  <BookOpen className="w-4 h-4" /> {p.readTimeMin} {T.minutes}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="mt-10 rounded-3xl p-6 flex flex-col md:flex-row items-center justify-between gap-4"
        style={{ backgroundImage: "linear-gradient(to right, var(--primary-color), var(--secondary-color))" }}>
        <p className="text-gray-800 font-medium">{T.subscribeLine}</p>
        <div className="flex w-full md:w-auto gap-2">
          <input
            type="email"
            placeholder="din@email.no"
            className="flex-1 rounded-full border border-[var(--primary-color)] px-4 py-2 focus:ring-[var(--primary-color)] focus:border-[var(--primary-color)]"
          />
          <button className="rounded-lg bg-[var(--primary-color)] hover:bg-[var(--primary-color)] text-white py-2 px-4">Abonner</button>
        </div>
      </div>

      {openPost ? <ArticleModal post={openPost} onClose={() => setOpenPost(null)} /> : null}
    </section>
  );
}